import React from 'react'
import { Tabs, TabList, TabPanels, Tab, TabPanel, Spinner, Flex, Text } from '@chakra-ui/react'
import {
  IFixtureCompetitionStageModel,
  IFixturesStore,
  ILadderCompetitionStageModel,
  ILaddersStore,
} from '../types/models'
import { observer } from 'mobx-react-lite'
import { filter, find, orderBy } from 'lodash'
import { useMst } from '../data/stores/rootStore'
import { CompetitionStage } from '../components/CompetitionStage/CompetitionStage'
import FooterLogo from '../assets/logo-ias.png'

export const Calc: React.FC = observer(() => {
  const {
    fixtures,
    ladders,
  }: {
    fixtures: IFixturesStore
    ladders: ILaddersStore
  } = useMst()

  fixtures.getFixture(process.env.REACT_APP_COMPETITION_ID)
  ladders.getLadder(process.env.REACT_APP_COMPETITION_ID)
  const fixtureData = fixtures.results.get(process.env.REACT_APP_COMPETITION_ID || '')?.fixture
  const ladderData = ladders.results.get(process.env.REACT_APP_COMPETITION_ID || '')?.ladder

  if (!fixtureData || !ladderData)
    return (
      <Flex w="100%" h="calc(100vh - 122px)" alignItems="center" justifyContent="center" padding="14px">
        <Flex direction="row">
          <Spinner />
          <Text marginLeft="14px" fontWeight="bold">
            Fetching data...
          </Text>
        </Flex>
      </Flex>
    )

  const competitionStagesLadders: ILadderCompetitionStageModel[] = filter(
    orderBy(ladderData.competitionStages, ['order'], ['asc']),
    (s: ILadderCompetitionStageModel) => {
      return (s.competitionLadders && s.competitionLadders.length > 0) ||
        (s.competitionPools && s.competitionPools.length > 0 && s.competitionPools[0].ladders.length > 0)
        ? true
        : false
    }
  )
  const competitionStagesFixtures: IFixtureCompetitionStageModel[] = orderBy(
    fixtureData.competitionStages,
    ['order'],
    ['asc']
  )

  return (
    <Flex w="100%" direction="column">
      <Flex
        w="100%"
        minW="calc(768px - 28px)"
        backgroundColor="#FFFFFF"
        alignItems="center"
        justifyContent="center"
        padding="14px"
      >
        {competitionStagesLadders.length === 1 && (
          <CompetitionStage
            ladder={find(competitionStagesLadders, { id: competitionStagesLadders[0].id })}
            fixture={find(competitionStagesFixtures, { id: competitionStagesLadders[0].id })}
          />
        )}
        {competitionStagesLadders.length > 1 && (
          <Tabs w="100%" size="lg" align="center" variant="enclosed" defaultIndex={competitionStagesLadders.length - 1}>
            <TabList>
              {competitionStagesLadders.map((s: ILadderCompetitionStageModel) => (
                <Tab key={`tab${s.id}`}>{s.name}</Tab>
              ))}
            </TabList>
            <TabPanels>
              {competitionStagesLadders.map((t: ILadderCompetitionStageModel) => (
                <TabPanel key={`tabPanel${t.id}`}>
                  <CompetitionStage
                    ladder={find(competitionStagesLadders, { id: t.id })}
                    fixture={find(competitionStagesFixtures, { id: t.id })}
                  />
                </TabPanel>
              ))}
            </TabPanels>
          </Tabs>
        )}
      </Flex>
      <Flex flex={1} direction="column" alignItems="center" padding="28px 0 14px">
        <Text fontSize="xs">Powered by:</Text>
        <img src={FooterLogo} alt="Powered by InteractSport - Part of SportRadar" width="228px" height="39px" />
        <Text marginTop="14px" fontSize="xs" color="nrr.textGray">
          v{process.env.REACT_APP_VERSION}
        </Text>
      </Flex>
    </Flex>
  )
})
